import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyslogRequest } from 'src/app/core/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SyslogService {
  url: string = environment.deviceHealthSyslogs;

  constructor(private httpClient: HttpClient) {}

  async getSyslogBlob(fileId: string): Promise<Blob> {
    const fileUrl = await this.httpClient
      .get<string>(`${this.url}/syslogs/${fileId}/url`)
      .toPromise();

    return this.httpClient
      .get<Blob>(fileUrl, {
        responseType: 'blob' as 'json',
      })
      .toPromise();
  }

  async getSyslog(fileId: string): Promise<SyslogRequest> {
    return this.httpClient
      .get<SyslogRequest>(`${this.url}/syslogs/${fileId}`, {
        headers: { 'Accept': 'application/json' }
      })
      .toPromise();
  }

  async getLiveSyslogs(serialNumber: string, lineCount: number): Promise<SyslogRow[]> {
    return this.httpClient
      .get<SyslogRow[]>(`${this.url}/syslogs/live/${serialNumber}?count=${lineCount}`)
      .toPromise();
  }

  async requestSyslog(serialNumber: string, type: 'dcc' | 'dcc-liveview'): Promise<string[]> {
    const request = {
      serialNumbers: [serialNumber],
      name: 'Live Request',
      description: 'Requested via Live Viewer',
      type: type
    };
    return await this.httpClient.post<string[]>(`${this.url}/syslogs`, request).toPromise();
  }
}



export interface SyslogRow {
  message: string;
  timestamp: string;
  process: { name: string }
  firmwareVersion: string
  companyId: number,
  serialNumber: string
}
